package com.essntl.features.message.ui.chat

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.features.notification.domain.model.NotificationModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class ChatState(
    val getAllWhapiMessages: State<List<WhapiMessageModel>> = State(),
    val getAllWhapiCalls: State<List<NotificationModel>> = State(),
    val getWhapiChat: State<WhapiChatModel> = State(),
    val getClients: State<List<ClientModel>> = State(),
    val getAllSupplier: State<List<SupplierModel>> = State(),
    val getAllTravelAgent: State<List<TravelAgentModel>> = State(),
    val getAllMessages: State<List<MessageModel>> = State(),
    val getCurrentProfile: State<ProfileModel> = State(),
) {
    val isLoading
        get() =
            getWhapiChat.isLoading ||
                getAllWhapiMessages.isLoading ||
                getClients.isLoading ||
                getAllSupplier.isLoading ||
                getAllTravelAgent.isLoading

    val isFailure
        get() =
            getWhapiChat.isFailure ||
                getAllWhapiMessages.isFailure ||
                getClients.isFailure ||
                getAllSupplier.isFailure ||
                getAllTravelAgent.isFailure
}